var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMainLogoWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 179,
    height: 19,
    viewBox: "0 0 179 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4616_2061)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.563 18.6717C169.846 18.6943 168.152 18.279 166.641 17.465C165.203 16.689 164.011 15.5293 163.196 14.1155C162.355 12.6649 161.925 11.0132 161.952 9.33746C161.924 7.66158 162.354 6.00969 163.196 4.55938C164.016 3.14516 165.213 1.98568 166.653 1.20989C169.357 -0.193005 172.53 -0.385014 175.383 0.681595C176.502 1.11848 177.509 1.79811 178.332 2.67129L177.084 3.90918C175.651 2.46497 173.828 1.73349 171.649 1.73349C170.262 1.71475 168.895 2.05452 167.679 2.71974C166.518 3.3637 165.555 4.31084 164.892 5.45967C164.211 6.63744 163.863 7.97781 163.886 9.33746C163.864 10.6966 164.211 12.0364 164.892 13.2137C165.557 14.3577 166.523 15.2985 167.685 15.9349C168.897 16.6133 170.266 16.9595 171.655 16.9383C173.847 16.9383 175.675 16.2068 177.09 14.7501L178.334 15.9739C177.504 16.8528 176.49 17.5366 175.363 17.9761C174.152 18.4469 172.862 18.6835 171.563 18.6732V18.6717Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.287 0.154785H155.346V18.5184H157.287V0.154785Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.198 1.83813H136.725V0.154785H151.596V1.83813H145.141V18.5184H143.198V1.83813Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.607 12.1586V18.5184H124.682V12.1586L117.324 0.154785H119.401L125.705 10.4596L132.008 0.154785H133.95L126.607 12.1586Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.193 0.154785H107.135V16.8351H117.425V18.5184H105.193V0.154785Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.3984 3.01194V0.154785H98.8231V3.01194H88.8231H85.3984Z",
    fill: "#00B3DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.3984 10.5956V7.79004H88.8231H91.6339H97.6988V10.5956H91.7357H88.8231H85.3984Z",
    fill: "#0078DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1973 15.6611V18.5183H85.3984V15.6611H88.8231H99.1973Z",
    fill: "#004B96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.043 0.158203H70.0824C72.0429 0.158203 73.7795 0.548952 75.3126 1.29763C76.7775 2.01634 78.0068 3.13704 78.8563 4.52833C79.6909 5.92252 80.1168 7.52147 80.1168 9.34079C80.1168 11.1601 79.6909 12.7575 78.8563 14.1517C78.009 15.5416 76.7825 16.6617 75.3204 17.3808C73.6879 18.1566 71.8981 18.546 70.0902 18.5187H62.043V15.6318H69.9289C71.1545 15.6574 72.3689 15.3951 73.4742 14.866C74.4672 14.383 75.2917 13.6129 75.8403 12.6559C76.4025 11.704 76.6765 10.599 76.6765 9.34079C76.7039 8.18004 76.4149 7.03365 75.8403 6.02412C75.2912 5.06749 74.4669 4.29754 73.4742 3.81405C72.3692 3.28422 71.1546 3.02184 69.9289 3.04818H62.043V0.158203Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0151 14.2686L51.8908 11.5975L48.4316 3.57305L44.9569 11.5975L43.8325 14.2686L41.9926 18.5184H38.416L46.7123 0.154785H47.597H49.2506H50.1354L58.4316 18.5184H54.8551L53.0151 14.2686Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8726 18.5187L28.1144 13.1467C27.9578 13.1639 27.7229 13.1639 27.416 13.1639H23.2538V18.5187H20.1016V10.3567H27.2563C28.7392 10.3567 29.8635 10.0348 30.6292 9.40487C31.395 8.77499 31.788 7.85751 31.788 6.68527C31.788 5.51302 31.4138 4.60961 30.6292 3.98129C29.8447 3.35296 28.7392 3.04349 27.2563 3.04349H20.1016V0.158203H27.4035C28.9882 0.158203 30.3787 0.430164 31.5594 0.956893C32.6764 1.41157 33.6296 2.1929 34.2935 3.19823C34.9199 4.18604 35.2331 5.34109 35.2331 6.68527C35.2331 8.06226 34.8932 9.2517 34.2277 10.2551C33.5622 11.2586 32.571 11.9901 31.3183 12.4824L35.5462 18.5187H31.8726Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.09961 0.154785H15.6047V3.04632H9.50549V18.5184H6.09961V4.6609V3.04632V0.154785Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.89539 0.154785H0V3.04476H2.89539V0.154785Z",
    fill: "#004B96"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4616_2061"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 178.333,
    height: 18.6735,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainLogoWhite);
export default __webpack_public_path__ + "static/media/mainLogoWhite.0e14475ce8314fa9d1ef9d874b1998cf.svg";
export { ForwardRef as ReactComponent };